import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, notification} from 'antd';

import {formItemLayout} from "../utils/style";
import {bindActionCreators} from "redux";
import {getReturnReason, updateReturnReason} from "./actions";
import {getDescriptionFromError} from "../utils/errors";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class AddDiscountReasonForm extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    // state
    loading: PropTypes.bool.isRequired,
    returnReason: PropTypes.object,
    // dispatch
    getReturnReason: PropTypes.func.isRequired,
    updateReturnReason: PropTypes.func.isRequired
  };

  async componentDidMount() {
    await this._load();
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.match.params.returnReasonId !== this.props.match.params.returnReasonId) await this._load();
  }

  async _load() {
    try {
      const {getReturnReason, match: {params}} = this.props;
      const {returnReasonId} = decodeParams(params);
      await getReturnReason({returnReasonId});
    } catch (e) {
      //
    }
  }

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const {updateReturnReason, form, match: {params}} = this.props;
    const {returnReasonId} = decodeParams(params);
    form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await updateReturnReason({...values, returnReasonId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading, returnReason} = this.props;
    return (
      <Card title="Update Return Reason">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              initialValue: returnReason && returnReason.name,
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input autoFocus/>
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Update Return Reason
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

const AddDiscountReasonPage = Form.create()(AddDiscountReasonForm);

const mapStateToProps = state => ({
  loading: state.returnReason.fetchingReturnReason || state.returnReason.addingReturnReason,
  returnReason: state.returnReason.returnReason,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  getReturnReason,
  updateReturnReason,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(AddDiscountReasonPage);



// WEBPACK FOOTER //
// ./src/ReturnReason/UpdateReturnReasonPage.js